import request from '@/utils/request'

// 查询登录日志列表
export function list(query) {
  return request({
    url: '/admin/loginLog/list',
    method: 'get',
    params: query
  })
}

// 删除登录日志
export function delLoginLog(data) {
  return request({
    url: '/admin/loginLog/remove',
    method: 'delete',
    data: data
  })
}
// 解锁用户登录状态
export function unlockLogin(userName) {
  return request({
    url: '/admin/loginLog/unlock/' + userName,
    method: 'get'
  })
}
// 清空登录日志
export function cleanLoginLog() {
  return request({
    url: '/admin/loginLog/clean',
    method: 'delete'
  })
}
